import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import Widget from 'components/Widget'
import WidgetCode from 'components/WidgetCode'
import SettingsDrawer from 'components/SettingsDrawer'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/pages/configurator'

@withStyles(styles)
@withAppStore
@observer
export default class extends Component {

  componentWillMount() {
    this.appStore.pageTitle = 'Конфигуратор виджета'
  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        <div className={ classes.paper } >
          <div className={ classes.container } >
            <Widget />
            <WidgetCode />
          </div>
        </div>
        <SettingsDrawer />
      </Fragment>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/configurator.js